import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const MosaicBath = {
  id: '66',
  name: "Mosaic Bath",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Mosaic_Bath',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Mosaic_Bath',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        0.5, 0.5, 1.0, 1.0, 1.5, 1.5, 2.0, 2.0, 2.5, 2.5,
        3.0, 3.0, 3.5, 3.5, 4.0, 4.0, 4.5, 4.5, 5.0, 5.0,
        5.5, 5.5, 6.0, 6.0, 6.5, 6.5, 7.0, 7.0, 7.5, 7.5,
        8.0, 8.0, 8.5, 8.5, 9.0, 9.0, 9.5, 9.5, 10.0, 10.1,
        10.1, 10.2, 10.3, 10.4, 10.4, 10.5, 10.6, 10.6, 10.7, 10.8,
        10.9, 10.9, 11.0, 11.1, 11.1, 11.2, 11.3, 11.4, 11.4, 11.5
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0,
        1, 1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3, 3,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
        7
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,10,10,10,10,15,15,20,20,25,25,25,25,30,30,35,35,40,40,40,40,50,50,60,60,70,70,70,70,80,80,90,90,100,100,110,110,120,121,125,128,131,134,137,140,143,146,149,152,156,159,162,165,168,171,174,177,180,183,187
        ],
        bronzeAge: [
          0,15,15,15,15,23,23,30,30,38,38,38,38,45,45,53,53,60,60,60,60,75,75,90,90,105,105,105,105,120,120,135,135,150,150,165,165,180,185,190,194,199,204,208,213,218,222,227,232,237,241,246,251,255,260,265,269,274,279,284
        ],
        minoanEra: [
          0,20,20,20,20,30,30,40,40,50,50,50,50,60,60,70,70,80,80,80,80,100,100,120,120,140,140,140,140,160,160,180,180,200,200,220,220,240,248,255,261,267,273,280,286,292,299,305,311,318,324,330,336,343,349,355,362,368,374,381
        ],
        classicGreece: [
          0,30,30,30,30,46,46,60,60,76,76,76,76,90,90,106,106,120,120,120,120,150,150,180,180,210,210,210,210,240,240,270,270,300,300,330,330,360,370,380,389,398,408,417,427,436,445,455,464,474,483,492,502,511,521,530,539,549,558,568
        ],
        earlyRome: [
          0,40,40,40,40,60,60,80,80,100,100,100,100,120,120,140,140,160,160,160,160,200,200,240,240,280,280,280,280,320,320,360,360,400,400,440,440,480,492,505,517,530,542,555,567,580,592,605,617,630,642,655,667,680,692,705,717,730,742,755
        ],
        romanEmpire: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        byzantineEra: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        ageOfTheFranks: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        feudalAge: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        iberianEra: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        kingdomOfSicily: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        highMiddleAges: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        earlyGothicEra: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ],
        lateGothicEra: [
          0,50,50,50,50,80,80,100,100,130,130,130,130,150,150,180,180,200,200,200,200,250,250,300,300,350,350,350,350,400,400,450,450,500,500,550,550,600,614,630,645,661,676,692,708,723,739,754,770,786,801,817,832,848,864,879,895,910,926,942
        ]
      }).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
  ]),
};

export default MosaicBath;
